function noop(..._args) {}
const identity = (t)=>t;
const isFunc = (f)=>'function' == typeof f;
export { identity, isFunc, noop };
